import * as React from 'react';
import '@swc/helpers';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import { getUpdatedUrlWithQueryParams, removeQueryParamsFromUrl } from '../../utils/get-updated-url-with-query-params.js';
import { updateUrlWithoutReload } from '../../utils/update-url.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';

const useHandleQueryParams = ()=>{
    const updateUrlQueryParam = React.useCallback((params)=>{
        updateUrlWithoutReload(getUpdatedUrlWithQueryParams(params));
    }, []);
    const deleteQueryParam = React.useCallback((params)=>{
        updateUrlWithoutReload(removeQueryParamsFromUrl(params));
    }, []);
    return [
        updateUrlQueryParam,
        deleteQueryParam
    ];
};

export { useHandleQueryParams };
//# sourceMappingURL=use-handle-query-params.js.map
